const json_parser = (data) => {
    return JSON.parse(data);
}
export default json_parser